import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useIsNodeActive } from './MenuNodeActive';
import { MenuContext } from '../../MenuContext';
import './MenuLeafNode.css'

export const MenuLeafNode = (
    {
        icon, // Si tiene icono es principal
        label,
        route,
        activeRoutes,
    },
) => {
    const { currentPathName, setNextPathName } = React.useContext(MenuContext);
    const select = () => setNextPathName(route);
    const activeClass = useIsNodeActive(activeRoutes, currentPathName);
    const classes = `ps-sidebar-menu-leaf ${activeClass}`;
    const classesWithIcon = `ps-sidebar-menu-leaf-with-icon ${activeClass}`;

    if ( !icon ) {
        return (
            <li className={classes}>
                <Link to={route} onClick={select}>{label}</Link>
            </li>
        );
    }

    return (
        <li className={classesWithIcon} >
            <Link to={route} onClick={select}>
                <i className="material-icons">{icon}</i>
                <span>{label}</span>
            </Link>
        </li>
    );
};

MenuLeafNode.propTypes = {
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    activeRoutes: PropTypes.array.isRequired,
};

MenuLeafNode.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/menu-nodes/MenuLeafNode.jsx